import { useTheme } from '@emotion/react';
import React, { useCallback, useState } from 'react';

import { Alert, Box, Collapse, Icon } from '~/components/blocks';
import { useOrganizationElectronicPrescription } from '~/hooks/use-organization-electronic-prescription';

export const NoAppointmentPrescriptionCollapse = React.memo(() => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const { electronicPrescription } = useOrganizationElectronicPrescription();

  const handleTitleClick = useCallback(() => setIsOpen((_isOpen) => !_isOpen), []);

  return (
    <Collapse
      open={isOpen}
      onClick={handleTitleClick}
      label={
        <>
          <Icon size="xxl" icon="drug" />
          {electronicPrescription ? '処方箋または処方内容（控え）' : '処方箋'}
        </>
      }
    >
      <Box padding={theme.space.m}>
        <Alert status="info">患者の持参した処方箋をご確認ください</Alert>
      </Box>
    </Collapse>
  );
});

NoAppointmentPrescriptionCollapse.displayName = 'NoAppointmentPrescriptionCollapse';
